import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

import { MOMENTOS_POR_ID } from '../constants/catalogoMomentos';
import type { MomentoPesquisa } from '../types/pesquisaSatisfacaoTypes';

const selectPesquisaSatisfacao = (state: RootState) => state.pesquisaSatisfacao;

export const selectMomentoAtivo = createSelector(
  selectPesquisaSatisfacao,
  (pesquisa): MomentoPesquisa | null =>
    pesquisa.momentoAtivoId ? (MOMENTOS_POR_ID[pesquisa.momentoAtivoId] ?? null) : null,
);

export const selectEstadoPesquisa = createSelector(
  selectPesquisaSatisfacao,
  (pesquisa) => pesquisa.estado,
);

export const selectNotaSelecionada = createSelector(
  selectPesquisaSatisfacao,
  (pesquisa) => pesquisa.nota,
);

export const selectComentario = createSelector(
  selectPesquisaSatisfacao,
  (pesquisa) => pesquisa.comentario,
);

export const selectCorrelacaoId = createSelector(
  selectPesquisaSatisfacao,
  (pesquisa) => pesquisa.correlacaoId,
);

export const selectOrigemAtiva = createSelector(
  selectPesquisaSatisfacao,
  (pesquisa) => pesquisa.origemAtiva,
);

export const selectTimerPausado = createSelector(
  selectPesquisaSatisfacao,
  (pesquisa) => pesquisa.timerPausado,
);

export const selectEnviandoComentario = createSelector(
  selectPesquisaSatisfacao,
  (pesquisa) => pesquisa.enviandoComentario,
);

export const selectContextoCarregado = createSelector(
  selectPesquisaSatisfacao,
  (pesquisa) => pesquisa.contextoCarregado,
);

/** O objeto que `resolverPesquisa` consome, menos o instante — que é do chamador. */
export const selectContextoPesquisa = createSelector(selectPesquisaSatisfacao, (pesquisa) => ({
  eventos: pesquisa.eventos,
  historico: pesquisa.historico,
  papel: pesquisa.papel,
  onboardingConcluidoEmIso: pesquisa.onboardingConcluidoEmIso,
  houveCriacao: pesquisa.houveCriacao,
  jaExibiuNestaSessao: pesquisa.jaExibiuNestaSessao,
}));
